import Cookies from "js-cookie";

export const setCookie = (key: string, value: any, expiryTime: number = 3600 * 24 * 30) => {
    Cookies.set(key, value, { expires: expiryTime });
};

export const getCookie = (key: string) => {
    return Cookies.get(key) || '';
};
